import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCombobox,_vm._b({attrs:{"items":['*' ].concat( _vm.resources),"label":_vm.$t('Resource'),"outlined":"","hide-details":"auto"},model:{value:(_vm.resource),callback:function ($$v) {_vm.resource=$$v},expression:"resource"}},'v-combobox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }